module.exports = __webpack_public_path__ + "img/Experiment Tutorial.b36af796.png";